export {
  createServerWebview,
  createBrowserWebview,
  createBrowserWebviewAndSetCookie,
} from "./webview";
export { Webview, NativeClient } from "./types";

declare global {
  interface Window {
    REAPackageVersions?: Record<string, string[]>;
  }
}
if (typeof window === "object") {
  window.REAPackageVersions = window.REAPackageVersions || {};
  window.REAPackageVersions["@realestate.com.au/webview"] =
    window.REAPackageVersions["@realestate.com.au/webview"] || [];
  window.REAPackageVersions["@realestate.com.au/webview"].push(
    "__@realestate.com.au/webview/version__",
  );
}
